import React from 'react';
import { AuthenticationWrapper } from './authentication/AuthenticationWrapper';
import { ToastProvider } from 'src/contexts/ToastContext';
import { CampaignAutomationPage } from './pages/campaignAutomation/CampaignAutomationPage';

const App = () => {
  return (
    <ToastProvider>
      <AuthenticationWrapper>
        <CampaignAutomationPage />
      </AuthenticationWrapper>
    </ToastProvider>
  );
};

export default App;
